export const MODAL_FEATURE_KEY = 'modal';
